import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import get from 'lodash/get';
import { Typography, useTheme, Icons } from '@hmsexp/component-library';
import { tableCellStyles } from './styles';
import { underscoreToText } from '../../../containers/OnlineReview/utils';

const TableCell = ({ column, lowSampleSize, isHeaderCell, ds, sample_size_data, index, row, sortColumns }) => {
  const theme = useTheme();
  const styles = tableCellStyles(theme);
  const label = get(column, 'label', '').toUpperCase();
  const field = get(column, 'field', '');
  const rightAlign = get(column, 'rightAlign', false);
  const value = get(row, field, '-');

  if (isHeaderCell) {
    return (
      <View style={[styles.headerWrap, index === 0 && styles.firstColumn, rightAlign && { alignItems: 'flex-end' }]}>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 4
          }}>
          <Typography variant='caption' fontWeightType='semiBold'>
            {underscoreToText(label)}
          </Typography>

          {sortColumns.includes(field) && (
            <TouchableOpacity style={{ marginLeft: 4, marginRight: 8 }}>
              <Icons.ChevronUp size='XS' color='primaryContentMedium' />
              <Icons.ChevronDown size='XS' color='primaryContentMedium' />
            </TouchableOpacity>
          )}
        </View>
      </View>
    );
  }
  const sampleSizeValue = sample_size_data?.[row?.index]?.[column?.field]
  const isLowSampleSize = Number.isFinite(sampleSizeValue) && sampleSizeValue < lowSampleSize;
  return (
    <View style={[styles.rowWrap, index === 0 && styles.firstColumn, rightAlign && { justifyContent: 'flex-end' }]}>
      {isLowSampleSize && <div
        style={{
          position: 'relative',
          width: 12,
          height: 12,
          borderRadius: '50%',
          border: '1.5px solid #D32F2F',
          overflow: 'hidden',
          flexShrink: 0
        }}>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '50%',
            backgroundColor: '#D32F2F'
          }}
        />
      </div>}
      <Typography variant='caption' fontWeightType='regular'
        textProps={{ style: { color: isLowSampleSize ? "#D32F2F" : "black" } }}
      >
        {
          Number.isFinite(value)
            ? value.toFixed(2)
            : underscoreToText(String(value))
        }
      </Typography>
    </View>
  );
};

export default TableCell;
